import {
  Building2,
  FileText,
  Landmark,
  LifeBuoy,
  Shield,
  User,
  Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type SettingsTab = {
  slug: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

/**
 * Single source of truth for the settings tabs — mirrors the `navItems`
 * pattern in components/layout/nav-items.ts. The desktop rail and the mobile
 * drill-down list both render from this, and the router validates `:tab`
 * against it.
 *
 * Adding a tab is one entry here plus a body component in SETTINGS_TABS'
 * consumer (Settings.tsx).
 */
export const SETTINGS_TABS: SettingsTab[] = [
  {
    slug: "profile",
    title: "Merchant profile",
    description: "Your personal details and login",
    icon: User,
  },
  {
    slug: "business",
    title: "Business details",
    description: "How your business appears to customers",
    icon: Building2,
  },
  {
    slug: "security",
    title: "Security",
    description: "Password and two-factor authentication",
    icon: Shield,
  },
  {
    slug: "banks",
    title: "Banks",
    description: "Where your payouts are settled",
    icon: Landmark,
  },
  {
    slug: "documents",
    title: "Documents",
    description: "Your verification documents and status",
    icon: FileText,
  },
  {
    slug: "managers",
    title: "Managers",
    description: "People who can manage this business",
    icon: Users,
  },
  {
    slug: "support",
    title: "Support",
    description: "Contact us, terms of service",
    icon: LifeBuoy,
  },
];

export const DEFAULT_SETTINGS_TAB = SETTINGS_TABS[0].slug;

export const isSettingsTab = (slug?: string): boolean =>
  SETTINGS_TABS.some((tab) => tab.slug === slug);
